<div class="p-dialog-header px-0">
  <div class="p-dialog-title">
    <div class="flex gap-spacing-xs align-items-center">
      <span class="title-small-bold text-primary-color">Send Delay Notification</span>
    </div>
  </div>
  <div class="p-dialog-header-icons">
    <app-button
      (btnClick)="ref.close()"
      [iconOnlyButton]="true"
      icon="icon-x"
      sizeClass="p-button-sm"
      severity="secondary"
      [textButton]="true"></app-button>
  </div>
</div>

<div class="content p-spacing-xl border-1 border-neutral-base-primary-border border-round-xl flex flex-column gap-spacing-xl table-bg-hover-bg">
  <form
    #delayNotificationForm="ngForm"
    class="flex flex-column gap-spacing-xl">
    <div class="form-group">
      <label
        class="input-label label-large-medium mb-spacing-default flex gap-spacing-default align-items-center"
        for="delayAlert"
        >Ride Delay Alert</label
      >
      <input
        id="delayAlert"
        ngModel
        required
        name="delayAlert"
        type="text"
        placeholder="Ride Delay Alert Title"
        pInputText />
    </div>

    <div class="form-group w-full">
      <textarea
        rows="5"
        cols="30"
        #description
        ngModel
        name="description"
        pTextarea
        [autoResize]="true"
        value="''"
        placeholder="Ride Delay Alert Description">
      </textarea>
    </div>
  </form>
</div>

<div class="footer py-spacing-2xl px-0 gap-spacing-xl flex justify-content-end gap-spacing-xl">
  <app-button
    label="Close"
    (btnClick)="ref.close()"
    sizeClass="p-button-md"
    severity="secondary"></app-button>
  <app-button
    [isLoading]="loading"
    [iconStart]="loading ? 'icon-spinner-gap' : ''"
    [disabled]="!delayNotificationForm.valid || loading"
    label="Send Notification"
    (btnClick)="confirmAction()"
    sizeClass="p-button-md"
    severity="primary"></app-button>
</div>
